import { render, staticRenderFns } from "./anamneseDashboardSettings.vue?vue&type=template&id=b9137404"
import script from "./anamneseDashboardSettings.vue?vue&type=script&lang=js"
export * from "./anamneseDashboardSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports